import React from 'react';
import Proptypes from 'prop-types';
import Plot from "react-plotly.js";
import Plotly from 'plotly.js/dist/plotly';

import _ from 'lodash';

//const parse = require('csv-parse/lib/es5/sync.js');

class FitContentPlotter extends React.Component {
    constructor(props) {
        super(props);

        this.onAutoSize = this.onAutoSize.bind(this);
    }

    render() {
        let data = this.props.data;  // this is not CSV data because there are no comma

        if (data) {

            let curveList = [];

            let xValues = [];
            let y1Values = [];
            let y2Values = [];
            let y1StdDevAreaHigh = [];
            let y1StdDevAreaLow = [];
            let splitData = data.toString().split("\n");

            for (let i = 0; i < splitData.length; i++) {
                let line = splitData[i].trim();
                let splitLine = line.split(/\s*[\s,]\s*/);
                if (splitLine.length === 3) {
                    xValues.push(splitLine[0])
                    y1Values.push(splitLine[1])
                    y2Values.push(splitLine[2])
                }
            }

            /* the curves shown in the graph */
            curveList.push(
                {
                    x: xValues,
                    y: y1Values,
                    type: 'scatter',
                    mode: 'lines',
                    name: 'I(exp)',
                    showlegend: true,
                    marker: { color: '#FF0000' },
                },
                {
                    x: xValues,
                    y: y2Values,
                    type: 'scatter',
                    mode: 'lines',
                    name: 'I(sim)',
                    showlegend: true,
                    marker: { color: '#0000FF' },
                },
            )

            /* the graph layout */
            let layout = {
                title: '',
                xaxis: {
                    title: 'q(nm<sup>-1</sup>)'
                },
                autosize: true
            }

            return <Plot
                data={curveList}
                divId='fitDataDiv'
                layout={layout}
                useResizeHandler={true}
                onAutoSize={this.onAutoSize}

            />
        } else {
            return null;
        }

    }

    onAutoSize() {
        let graphElement = document.getElementById('fitDataDiv');

        if (graphElement) {
            this.height = graphElement.parentNode.offsetHeight;
            this.width = graphElement.parentNode.offsetWidth;
            Plotly.relayout('fitDataDiv', {
                width: this.width,
                height: 400
            })
        }

    }

}

export default FitContentPlotter;

FitContentPlotter.proptypes = {
    /** csv data */
    data: Proptypes.string
}



// WEBPACK FOOTER //
// ./src/components/saxs/FitContentPlotter.js